import { render } from "./CFPInfo.vue?vue&type=template&id=11068b52&scoped=true"
import script from "./CFPInfo.vue?vue&type=script&lang=js"
export * from "./CFPInfo.vue?vue&type=script&lang=js"

import "./CFPInfo.vue?vue&type=style&index=0&id=11068b52&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11068b52"]])

export default __exports__